import React from 'react'
import i18n from 'live/services/i18n'
import { PackageResource, PluginRequirement } from '../http/api'
import { selectPluginDependencies } from './utils'
import { Row, CardContent } from './styles'

const PluginsCard: React.VFC<{ package: PackageResource }> = ({ package: pkg }) => {
    const dependencies = selectPluginDependencies(pkg.requiredPlugins)

    if (!dependencies.length) {
        return null
    }

    const items = dependencies.map(dependency => <PluginItem key={dependency.name} dependency={dependency} />)

    return (
        <CardContent>
            <h3 className="title">{i18n('Required plugins')}</h3>
            <div className="feature-warning">
                {i18n('For more details, go to the ')}
                <a href="#plugins">{i18n('plugins screen')}</a>
            </div>
            <div className="feature-table">
                <div className="feature-table-head">
                    <div className="col-md-5">{i18n('Plugin name')}</div>
                    <div className="col-md-5">{i18n('Version constraint')}</div>
                    {/* <div className="col-md-1">{i18n('Status')}</div> */}
                    <div className="col-md-1" />
                </div>
                <div className="feature-table-body">{items}</div>
            </div>
        </CardContent>
    )
}

export default PluginsCard

interface PluginItemProps {
    dependency: PluginRequirement
}

const PluginItem = ({ dependency }: PluginItemProps) => {
    return (
        <>
            <Row className="feature-table-row">
                <div className="col-md-5">{dependency.name}</div>
                <div className="col-md-5">{dependency.version ?? i18n('no version constraint')}</div>
                {/* <div className="col-md-1">&nbsp;</div> */}
            </Row>
        </>
    )
}
